module.exports = __webpack_public_path__ + "static/media/IMG_20180808_202436.9ce191b0.jpg";